"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableRender = void 0;
require("es6-symbol/implement");
var React = __importStar(require("react"));
var Header_1 = __importDefault(require("./Header/Header"));
var Column_1 = __importDefault(require("./Column/Column"));
var ActionBar_1 = __importDefault(require("./ActionBar/ActionBar"));
var HeaderBar_1 = __importDefault(require("./HeaderBar/HeaderBar"));
var Pagination_1 = __importDefault(require("./Pagination/Pagination"));
var common_1 = require("@scuf/common");
var react_1 = require("react");
var localization_1 = require("@scuf/localization");
var column_1 = require("primereact/column");
var paginationHelper_1 = require("../../util/paginationHelper");
var datatable_1 = require("primereact/datatable");
var selectionHelpers_1 = require("../../util/selectionHelpers");
var cellContentHelpers_1 = require("../../util/cellContentHelpers");
var DataTableRender = /** @class */ (function (_super) {
    __extends(DataTableRender, _super);
    function DataTableRender(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPagination = function () {
            var _a = _this.props, loading = _a.loading, data = _a.data;
            var pagination = _this.getChild(Pagination_1.default);
            var _b = pagination.props, onPageChange = _b.onPageChange, activePage = _b.activePage, itemsPerPage = _b.itemsPerPage, itemsPerPageOptions = _b.itemsPerPageOptions, className = _b.className, totalItems = _b.totalItems, rest = __rest(_b, ["onPageChange", "activePage", "itemsPerPage", "itemsPerPageOptions", "className", "totalItems"]);
            var itemCount = totalItems || _this.genFilteredRecordsCount();
            if (typeof itemCount === 'undefined') {
                itemCount = data.length;
            }
            var isPageOptions = false;
            if (itemsPerPageOptions) {
                isPageOptions = true;
            }
            var props = __assign({ onPageChange: isPageOptions ? onPageChange : _this.onPageChangeWrap(activePage, itemsPerPage, onPageChange), totalItems: itemCount, activePage: activePage || _this.state.activePage, itemsPerPage: itemsPerPage || _this.state.itemsPerPage, className: _this.genPaginationClasses(className, loading) }, rest);
            return React.cloneElement(pagination, props);
        };
        _this.genPaginationClasses = function (className, isLoading) {
            var classes = 'datatable-pagination';
            if (className) {
                classes += " " + className;
            }
            if (isLoading) {
                classes += ' loading';
            }
            return classes;
        };
        _this.onPageChangeWrap = function (activePage, itemsPerPage, onPageChange) {
            return function (page) {
                _this.setState({
                    activePage: activePage || page,
                    itemsPerPage: itemsPerPage || _this.state.itemsPerPage,
                }, function () {
                    _this.setSelectionState();
                    return onPageChange && onPageChange(page, itemsPerPage);
                });
            };
        };
        _this.onSelectionWrap = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var _a, onSelectionChange, selectionMode, selection, showActionBar, newSelection;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, onSelectionChange = _a.onSelectionChange, selectionMode = _a.selectionMode;
                        selection = e.value;
                        showActionBar = selection.length !== 0;
                        this.setState({ showActionBar: showActionBar });
                        if (!onSelectionChange) return [3 /*break*/, 2];
                        newSelection = selection;
                        if (selectionMode === 'single') {
                            newSelection = selection.length > 0 ? [selection.pop()] : [];
                        }
                        return [4 /*yield*/, onSelectionChange(newSelection)];
                    case 1:
                        _b.sent();
                        this.setSelectionState();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.onSortWrap = function (e) {
            var _a = _this.props, onSort = _a.onSort, scrollable = _a.scrollable;
            var _b = _this.state, sortField = _b.sortField, sortOrder = _b.sortOrder;
            var activePage = _this.getChild(Pagination_1.default) ? { activePage: 1 } : {};
            var reset = sortField === e.sortField && sortOrder === -1;
            if (reset) {
                _this.setState(__assign({ sortField: '', sortOrder: undefined }, activePage), function () {
                    _this.setSelectionState();
                });
            }
            else {
                _this.setState(__assign({ sortField: e.sortField, sortOrder: e.sortOrder }, activePage), function () {
                    _this.setSelectionState();
                });
            }
            if (scrollable && _this.wrapRef) {
                var scrollBody = _this.wrapRef.querySelector('.p-datatable-scrollable-body');
                if (scrollBody) {
                    scrollBody.scrollTop = 0;
                }
            }
            return onSort && onSort({ sortField: e.sortField, sortOrder: e.sortOrder });
        };
        _this.populateTable = function () {
            var selectionMode = _this.props.selectionMode;
            var children = _this.genColumns();
            var shouldAddSelectionColumn = selectionMode === 'multiple' || !children.find(function (c) { return c.props.selectionMode === 'multiple'; });
            if (selectionMode && children && shouldAddSelectionColumn) {
                children.unshift(React.createElement(column_1.Column, { columnKey: "select", selectionMode: "multiple", key: React.Children.toArray(_this.props.children).length, loadingBody: _this.loadingBody }));
            }
            return children;
        };
        _this.genClasses = function () {
            var _a = _this.props, className = _a.className, selectionMode = _a.selectionMode, showHeader = _a.showHeader, onCellClick = _a.onCellClick, onRowClick = _a.onRowClick;
            var classes = '';
            if (className) {
                classes = className;
            }
            if (selectionMode && selectionMode === 'single') {
                classes += ' hide-checkbox';
            }
            if (!showHeader) {
                classes += ' hide-header';
            }
            if (onCellClick || onRowClick) {
                classes += ' hover-over';
            }
            return classes;
        };
        _this.genColumns = function () {
            var children = React.Children.toArray(_this.props.children);
            var columns = children.reduce(function (columnsAccumulator, child, index) {
                if (React.isValidElement(child) && child.type === Column_1.default) {
                    var base = child;
                    var props = __assign({ key: index, body: _this.cellRender.bind(_this.props), style: { width: base.props.initialWidth }, className: cellContentHelpers_1.genCellClasses(base.props), loadingBody: _this.loadingBody, editorValidatorEvent: 'click' }, (base.props.editable && { editor: _this.editorRender(base.props) }));
                    var clone = React.cloneElement(base, props);
                    columnsAccumulator.push(clone);
                }
                return columnsAccumulator;
            }, []);
            return columns;
        };
        _this.cellRender = function (rowData, column) {
            return cellContentHelpers_1.cellRender(rowData, column, _this.props);
        };
        _this.editorRender = function (columnProps) {
            return cellContentHelpers_1.editorRender(columnProps, _this.props);
        };
        _this.clearSelection = function (clearSelection) {
            if (clearSelection) {
                _this.onSelectionWrap({ originalEvent: {}, value: [] });
            }
        };
        _this.genHeader = function () {
            var _a = _this.state, showActionBar = _a.showActionBar, filterValue = _a.filterValue, isSelectAllChecked = _a.isSelectAllChecked;
            var _b = _this.props, data = _b.data, selectionMode = _b.selectionMode, search = _b.search, totalRecords = _b.totalRecords, onGlobalFilter = _b.onGlobalFilter, searchPlaceholder = _b.searchPlaceholder, selection = _b.selection, selectionCount = _b.selectionCount, i18nTotal = _b.i18nTotal;
            var actionBar = _this.getChild(ActionBar_1.default);
            var headerBar = _this.getChild(HeaderBar_1.default);
            var totalRecordCount = _this.genFilteredRecordsCount() || totalRecords;
            var barSelectionCount = selectionCount ? selectionCount : selection ? selection.length : 0;
            if ((showActionBar && actionBar) || headerBar || search) {
                return (React.createElement(React.Fragment, null,
                    selectionMode === 'multiple' && Boolean(data.length) && (React.createElement(common_1.Checkbox, { className: "select-all-checkbox", checked: isSelectAllChecked, onChange: _this.handleSelectAll })),
                    React.createElement(Header_1.default, { selections: barSelectionCount, showActionBar: showActionBar, data: data, search: search, selectionMode: selectionMode, totalRecords: totalRecordCount, menuBar: headerBar, actionBar: actionBar, globalFilterValue: filterValue, searchPlaceholder: searchPlaceholder, i18nTotal: i18nTotal, hideActionBar: function (clearSelection) {
                            _this.clearSelection(clearSelection);
                            _this.setState({ showActionBar: false });
                        }, onSearchChange: function (value) {
                            var activePage = typeof _this.state.activePage === 'number' && 1;
                            _this.setState(__assign({ filterValue: value }, (activePage && { activePage: activePage })), function () { return _this.setSelectionState(); });
                            return onGlobalFilter && onGlobalFilter(value);
                        } })));
            }
            else {
                return null;
            }
        };
        _this.genFilteredRecordsCount = function () {
            var _a = _this.state, filterValue = _a.filterValue, visibleFields = _a.visibleFields;
            var _b = _this.props, data = _b.data, search = _b.search, onGlobalFilter = _b.onGlobalFilter;
            var actionBar = _this.getChild(ActionBar_1.default);
            var filteredRecordsCount;
            if (data && !onGlobalFilter && (actionBar || search) && filterValue.length > 0) {
                var filtered = paginationHelper_1.filterData(data, filterValue, visibleFields);
                filteredRecordsCount = filtered.length;
            }
            return filteredRecordsCount;
        };
        _this.setSelectionState = function () {
            var selectionMode = _this.props.selectionMode;
            if (selectionMode) {
                var isSelectAllChecked = selectionHelpers_1.areAllPageItemsSelected(_this.props, _this.state);
                if (isSelectAllChecked !== _this.state.isSelectAllChecked) {
                    _this.setState({ isSelectAllChecked: isSelectAllChecked });
                }
            }
        };
        _this.handleSelectAll = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var isSelectAllChecked, _a, onSelectionChange, selection, onSelectAll, value, newSelection;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isSelectAllChecked = this.state.isSelectAllChecked;
                        _a = this.props, onSelectionChange = _a.onSelectionChange, selection = _a.selection, onSelectAll = _a.onSelectAll;
                        value = this.getTableData();
                        if (onSelectAll) {
                            onSelectAll(e);
                        }
                        if (!onSelectionChange) return [3 /*break*/, 2];
                        newSelection = void 0;
                        if (isSelectAllChecked) {
                            newSelection = selection.filter(function (item) {
                                return !value.includes(item);
                            });
                        }
                        else if (selection) {
                            newSelection = value.concat(selection.filter(function (item) {
                                return value.indexOf(item) < 0;
                            }));
                        }
                        else {
                            newSelection = value;
                        }
                        return [4 /*yield*/, onSelectionChange(newSelection)];
                    case 1:
                        _b.sent();
                        this.setSelectionState();
                        this.setState({ showActionBar: e });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.loadingBody = function () { return (React.createElement("div", { className: "datatable-loading-body" },
            React.createElement("div", { className: "loading-indicator" }))); };
        _this.getChild = function (type) {
            var test = React.Children.toArray(_this.props.children).find(function (child) { return typeof child === 'object' && child.type === type; });
            return test;
        };
        _this.getTableData = function () {
            var _a = _this.state, activePage = _a.activePage, itemsPerPage = _a.itemsPerPage, sortField = _a.sortField, sortOrder = _a.sortOrder, filterValue = _a.filterValue, paginate = _a.paginate, visibleFields = _a.visibleFields;
            var _b = _this.props, data = _b.data, lazy = _b.lazy;
            return paginate && !lazy ? paginationHelper_1.getPageEntries(data, activePage, itemsPerPage, visibleFields, sortOrder, sortField, filterValue) : data;
        };
        _this.genWrapperClasses = function () {
            var _a = _this.props, search = _a.search, selection = _a.selection, scrollWidth = _a.scrollWidth, showHeader = _a.showHeader;
            var actionBar = _this.getChild(ActionBar_1.default);
            var headerBar = _this.getChild(HeaderBar_1.default);
            var classes = 'ui forge-datatable-wrap';
            if (search) {
                classes += ' search';
            }
            if (actionBar) {
                classes += ' actionbar';
            }
            if (headerBar) {
                classes += ' header-bar';
            }
            if (scrollWidth) {
                classes += ' h-scrollable';
            }
            if (selection && selection.length > 0) {
                classes += ' selection';
            }
            if (!showHeader) {
                classes += ' hide-checkbox';
            }
            return classes;
        };
        _this.state = {
            filterValue: props.globalFilterValue ? props.globalFilterValue : '',
            showActionBar: false,
            sortField: '',
            sortOrder: undefined,
            isSelectAllChecked: false,
            isScrollable: false,
            visibleFields: [],
        };
        return _this;
    }
    DataTableRender.prototype.componentDidMount = function () {
        var _a = this.props, selection = _a.selection, data = _a.data, rows = _a.rows;
        var pagination = this.getChild(Pagination_1.default);
        var all = selection && !pagination && data.length && selection.length === data.length ? true : false;
        var newState = {};
        var visibleFields = this.genColumns().map(function (column) { return column.props.field; });
        if (pagination) {
            Object.assign(newState, {
                activePage: 1,
                itemsPerPage: pagination.props.itemsPerPage || rows || 10,
                paginate: true,
            });
        }
        if (all) {
            Object.assign(newState, { isSelectAllChecked: all });
        }
        if (selection && selection.length) {
            Object.assign(newState, { showActionBar: true });
        }
        this.setState(__assign(__assign({}, newState), { visibleFields: visibleFields }));
    };
    DataTableRender.prototype.componentDidUpdate = function (prevProps, prevState) {
        var isSelectAllChecked = selectionHelpers_1.areAllPageItemsSelected(this.props, this.state);
        if (this.state.isSelectAllChecked !== isSelectAllChecked) {
            this.setState({ isSelectAllChecked: isSelectAllChecked });
        }
        if (this.props.scrollable) {
            var tbody = this.wrapRef && this.wrapRef.querySelector('.p-datatable-tbody');
            if (tbody && this.props.scrollHeight) {
                if (tbody.offsetHeight >= parseInt(this.props.scrollHeight)) {
                    if (!prevState.isScrollable)
                        this.setState({ isScrollable: true });
                }
                else {
                    if (prevState.isScrollable)
                        this.setState({ isScrollable: false });
                }
            }
        }
    };
    DataTableRender.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, onRowClick = _a.onRowClick, onRowDoubleClick = _a.onRowDoubleClick, className = _a.className, search = _a.search, t = _a.t, lng = _a.lng, emptyMessage = _a.emptyMessage, scrollWidth = _a.scrollWidth, globalFilterValue = _a.globalFilterValue, onGlobalFilter = _a.onGlobalFilter, onSort = _a.onSort, virtualRowHeight = _a.virtualRowHeight, onEdit = _a.onEdit, selectionMode = _a.selectionMode, lazy = _a.lazy, pSortField = _a.sortField, pSortOrder = _a.sortOrder, selection = _a.selection, scrollable = _a.scrollable, scrollHeight = _a.scrollHeight, rest = __rest(_a, ["data", "onRowClick", "onRowDoubleClick", "className", "search", "t", "lng", "emptyMessage", "scrollWidth", "globalFilterValue", "onGlobalFilter", "onSort", "virtualRowHeight", "onEdit", "selectionMode", "lazy", "sortField", "sortOrder", "selection", "scrollable", "scrollHeight"]);
        var _b = this.state, filterValue = _b.filterValue, sortField = _b.sortField, sortOrder = _b.sortOrder, paginate = _b.paginate, isSelectAllChecked = _b.isSelectAllChecked, isScrollable = _b.isScrollable;
        var value = this.getTableData();
        var header = this.genHeader();
        var showCheckbox = !header && selectionMode === 'multiple' && Boolean(data.length);
        return (React.createElement("div", { className: this.genWrapperClasses(), ref: function (ref) { return (_this.wrapRef = ref); } },
            showCheckbox && React.createElement(common_1.Checkbox, { className: "select-all-checkbox", checked: isSelectAllChecked, onChange: this.handleSelectAll }),
            React.createElement(datatable_1.DataTable, __assign({}, rest, { scrollable: isScrollable, scrollHeight: scrollHeight, lazy: lazy, selection: selection, sortField: pSortField ? pSortField : sortField, sortOrder: pSortOrder ? pSortOrder : sortOrder, onSort: this.onSortWrap, value: value, virtualScrollDelay: 50, metaKeySelection: false, className: this.genClasses(), globalFilter: typeof onGlobalFilter === 'function' ? '' : filterValue, header: header, virtualRowHeight: virtualRowHeight, onSelectionChange: this.onSelectionWrap, loadingIcon: "h-icon global refresh loading", style: scrollWidth ? { width: scrollWidth } : {}, emptyMessage: emptyMessage ? emptyMessage : t('No records found'), onRowClick: onRowClick ? function (_a) {
                    var row = _a.data, index = _a.index;
                    return onRowClick({ data: row, index: index });
                } : undefined, onRowDoubleClick: onRowDoubleClick ? function (_a) {
                    var row = _a.data, index = _a.index;
                    return onRowDoubleClick({ data: row, index: index });
                } : undefined }), this.populateTable()),
            paginate && (React.createElement("div", { className: "datatable-pagination-wrap" },
                this.renderPagination(),
                React.createElement("div", { className: "pagination-loading-overlay" })))));
    };
    DataTableRender.defaultProps = {
        virtualRowHeight: 32,
    };
    DataTableRender.getDerivedStateFromProps = function (props, state) {
        var update = null;
        var filterValuesAreDifferent = state.previousFilterValue !== props.globalFilterValue;
        if (filterValuesAreDifferent) {
            update = {
                filterValue: props.globalFilterValue,
                previousFilterValue: props.globalFilterValue,
            };
        }
        return update;
    };
    return DataTableRender;
}(react_1.Component));
exports.DataTableRender = DataTableRender;
exports.default = localization_1.InjectLocalization(DataTableRender);
//# sourceMappingURL=DataTableRender.js.map